import { createSlice } from '@reduxjs/toolkit'
import { apiSlice } from './api/apiSlice'

const initialState = {
  data: {
    scannedMortgages: [],
    viewingFromSearchBool: false,
    viewingMortgageFromSearch: null,
    propertySearchResponse: {
      dataPresent: false,
      recordDetailsObj: null,
      propMixSuccessDate: null,
      attomSuccessDate: null,
      coreLogicSuccessDate: null,
      existingInitialSweeps: 0,
      rejectionsAttomDataExpected: 0,
      rejectionsCoreLogicDataExpected: 0,
      rejectionsAttomAndCoreLogicDataExpected: 0,
      rejectionsAttomDataNew: 0,
      rejectionsCoreLogicDataNew: 0,
      rejectionsAttomAndCoreLogicDataNew: 0,
    },
  },
  status: 'idle',
  error: null
}

export const viewingSearchResultsSlice = createSlice({
  name: 'viewingSearchResults',
  initialState,
  reducers: {
    addToScannedMortgages(state, action) {
      let match = state.data.scannedMortgages.find(mortgage => mortgage.mortgageId.toString() === action.payload.mortgageId.toString())
      if (!match) {
        state.data.scannedMortgages.push(action.payload)
      }
    },
    setViewingFromSearchBool(state, action) {
      state.data.viewingFromSearchBool = action.payload
    },
    setViewingMortgageFromSearch(state, action) {
      state.data.viewingMortgageFromSearch = action.payload
    },
    setExistingInitialSweeps(state, action) { state.data.propertySearchResponse.existingInitialSweeps = action.payload },
    setRejectionsAttomDataExpected(state, action) { state.data.propertySearchResponse.rejectionsAttomDataExpected = action.payload },
    setRejectionsCoreLogicDataExpected(state, action) { state.data.propertySearchResponse.rejectionsCoreLogicDataExpected = action.payload },
    setRejectionsAttomAndCoreLogicDataExpected(state, action) { state.data.propertySearchResponse.rejectionsAttomAndCoreLogicDataExpected = action.payload },
    setRejectionsAttomDataNew(state, action) { state.data.propertySearchResponse.rejectionsAttomDataNew = action.payload },
    setRejectionsCoreLogicDataNew(state, action) { state.data.propertySearchResponse.rejectionsCoreLogicDataNew = action.payload },
    setRejectionsAttomAndCoreLogicDataNew(state, action) { state.data.propertySearchResponse.rejectionsAttomAndCoreLogicDataNew = action.payload },
    clearPropertySearchResponse(state, action) { state.data.propertySearchResponse = {}; state.data.viewingMortgageFromSearch = null },
  },
  extraReducers: (builder) => {
    builder
    .addMatcher(apiSlice.endpoints.runPropertySearch.matchFulfilled, (state, {payload}) => {
      if (payload.data.recordDetailsObj && !payload.data.fileUpload) {
        state.data.propertySearchResponse.dataPresent = true
        state.data.propertySearchResponse.recordDetailsObj = payload.data.recordDetailsObj
        state.data.propertySearchResponse.propMixSuccessDate = payload.data.propMixSuccessDate
        state.data.propertySearchResponse.attomSuccessDate = payload.data.attomSuccessDate
        state.data.propertySearchResponse.coreLogicSuccessDate = payload.data.coreLogicSuccessDate
      }
    })
    .addMatcher(apiSlice.endpoints.saveProperty.matchFulfilled, (state, {payload}) => {
      if (payload.data && payload.data.saveFromSearch && payload.data.newMortgage) {
        state.data.viewingMortgageFromSearch = payload.data.newMortgage
      }
    })
  },
})

export const { addToScannedMortgages, setViewingFromSearchBool, setViewingMortgageFromSearch, setExistingInitialSweeps, setRejectionsAttomDataExpected, setRejectionsCoreLogicDataExpected, setRejectionsAttomAndCoreLogicDataExpected, setRejectionsAttomDataNew, setRejectionsCoreLogicDataNew, setRejectionsAttomAndCoreLogicDataNew, clearPropertySearchResponse } = viewingSearchResultsSlice.actions

export default viewingSearchResultsSlice.reducer

export const selectScannedMortgages = state => state.viewingSearchResults.data.scannedMortgages
export const selectViewingFromSearchBool = state => state.viewingSearchResults.data.viewingFromSearchBool
export const selectExistingInitialSweeps = state => state.viewingSearchResults.data.propertySearchResponse.existingInitialSweeps
export const selectPropertySearchResponse = state => state.viewingSearchResults.data.propertySearchResponse
export const selectRejectionsAttomDataNew = state => state.viewingSearchResults.data.propertySearchResponse.rejectionsAttomDataNew
export const selectViewingMortgageFromSearch = state => state.viewingSearchResults.data.viewingMortgageFromSearch
export const selectRejectionsCoreLogicDataNew = state => state.viewingSearchResults.data.propertySearchResponse.rejectionsCoreLogicDataNew
export const selectRejectionsAttomDataExpected = state => state.viewingSearchResults.data.propertySearchResponse.rejectionsAttomDataExpected
export const selectRejectionsCoreLogicDataExpected = state => state.viewingSearchResults.data.propertySearchResponse.rejectionsCoreLogicDataExpected
export const selectRejectionsAttomAndCoreLogicDataNew = state => state.viewingSearchResults.data.propertySearchResponse.rejectionsAttomAndCoreLogicDataNew
export const selectRejectionsAttomAndCoreLogicDataExpected = state => state.viewingSearchResults.data.propertySearchResponse.rejectionsAttomAndCoreLogicDataExpected
